/* Solution絞り込み */
export default class SolutionFilter {
    constructor() {
        this.tags = document.querySelectorAll('.solution-category-taglist > li > a[href^="#solution_"]');
        this.targets = document.querySelectorAll('.js-solution-filter');
        this.hash = location.hash;
        this.init();
    }
    init() {
        this.tags.forEach((elm) => {
            elm.addEventListener('click', (ev) => {
                const trigger = ev.target;
                const id = trigger.getAttribute('href').replace('#', '');
                ev.preventDefault();
                // 絞り込み表示
                if (id === 'solution_all') {
                    this.targets.forEach((elm) => {
                        const targetContents = elm;
                        targetContents.classList.remove('is-hidden');
                    });
                }
                else {
                    const target = document.getElementById(id);
                    this.targets.forEach((elm) => {
                        const hideContents = elm;
                        hideContents.classList.add('is-hidden');
                        target.classList.remove('is-hidden');
                    });
                }
                // ボタン変化
                this.tags.forEach((elm) => {
                    elm.parentElement.classList.remove('active');
                });
                trigger.parentElement.classList.add('active');
                // Lenis最大スクロール量調整用
                window.dispatchEvent(new Event('resize'));
            });
        });
        // 外部からの絞り込みリンク
        if (this.hash) {
            const hashTarget = document.querySelector('.solution-category-taglist > li > a[href="' + this.hash + '"]');
            location.hash = '';
            history.replaceState('', document.title, window.location.pathname);
            if (hashTarget) {
                hashTarget.dispatchEvent(new Event('click'));
            }
        }
    }
}
